{
  "baseLayout": {
    "backButton": "Retour",
    "menuButton": "Menu"
  },
  "reporting": {
    "selectReportButton": "Sélectionner un rapport",
    "viewBookingButton": "Voir la réservation"
  },
  "bookingButtons": {
    "addFavJourneyButton": "Ajouter un trajet favori",
    "clearFavJourneyButton": "Supprimer le trajet favori",
    "editBookingButton": "Modifier la réservation",
    "shareBookingButton": "Partager la réservation",
    "sendConfirmationButton": "Envoyer la confirmation",
    "copyBookingButton": "Copier la réservation",
    "returnBookingButton": "Réservation retour",
    "cancelBookingButton": "Annuler la réservation",
    "addToCalendarButton": "Ajouter la réservation au calendrier",
    "moreActionsButton": "Plus d'actions de réservation"
  },
  "newBooking": {
    "favJourneyCard": "Réserver un trajet favori",
    "recentJourneyCard": "Réserver un trajet récent",
    "favJourneyEdit": "Modifier la description du trajet favori",
    "favJourneyClear": "Supprimer le trajet favori",
    "selectBookingTemplateButton": "Commencer la réservation"
  },
  "masquerading": {
    "changeContactButton": "Changer de contact",
    "selectContactButton": "Sélectionner un contact",
    "clearContactButton": "Effacer le contact"
  },
  "bookingForm": {
    "stops": {
      "editStopButton": "Modifier l'adresse de l'arrêt",
      "saveAddressButton": "Enregistrer l'adresse dans le profil",
      "removeStopButton": "Supprimer l'arrêt",
      "reorderStops": "Réorganiser les arrêts",
      "selectFlightCard": "Sélectionner un vol",
      "removeFlightButton": "Supprimer les détails du vol",
      "stopsInputAccordion": "Voir plus de détails",
      "mapSearchButton": "Recherche sur la carte",
      "asDirectedButton": "Sur instruction",
      "clearSearchButton": "Effacer la recherche",
      "selectAddressButton": "Sélectionner l'adresse"
    },
    "tariffs": {
      "reverseSort": "Inverser le tri des tarifs"
    }
  },
  "profile": {
    "cards": {
      "makeDefaultCardButton": "Définir comme carte par défaut",
      "deleteCardButton": "Supprimer la carte",
      "selectCard": "Sélectionner la carte"
    },
    "addresses": {
      "addAddressButton": "Ajouter une nouvelle adresse",
      "addressFilterButton": "Filtre d'adresses",
      "reorderAddresses": "Réorganiser les adresses"
    },
    "addContactLinkButton": "Ajouter un lien de contact"
  },
  "selectProfileCard": "Sélectionner un profil",
  "clearSelectionButton": "Effacer la sélection",
  "refreshChip": "Actualiser le contenu",
  "passwordToggle": "Afficher ou masquer le mot de passe",
  "countryInputField": "Sélectionner un pays / une région",
  "localeInput": "Sélectionner la langue",
  "viewBooking": {
    "openDocument": "Ouvrir le document"
  }
}
